<template>
  <Panel :header="t('Status do serviço')" data-testid="agent-health">
    <div class="assistant-config-health-row">
      <span class="assistant-config-health-label">{{ t('Disponibilidade') }}</span>
      <Tag
        :severity="healthSeverity"
        :value="healthLabel"
        data-testid="agent-health-status"
      />
    </div>
    <div class="assistant-config-health-row">
      <span class="assistant-config-health-label">{{ t('Prontidão') }}</span>
      <Tag
        :severity="readySeverity"
        :value="readyLabel"
        data-testid="agent-health-ready"
      />
    </div>
    <Button
      class="assistant-config-refresh"
      :label="t('Atualizar')"
      icon="pi pi-refresh"
      severity="secondary"
      text
      :loading="checking"
      data-testid="agent-health-refresh"
      @click="refreshHealth"
    />
  </Panel>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAgentHealth } from '../../composables/useAgentHealth';

const { t } = useI18n();

const { status, ready, checking, check, checkReady } = useAgentHealth();

const healthLabel = computed<string>(() => {
  if (status.value === 'ok') return t('Online');
  if (status.value === 'unreachable') return t('Inacessível');
  return t('Verificando…');
});
const healthSeverity = computed<string>(() => {
  if (status.value === 'ok') return 'success';
  if (status.value === 'unreachable') return 'danger';
  return 'secondary';
});

const readyLabel = computed<string>(() => {
  if (ready.value === 'ready') return t('Pronto');
  if (ready.value === 'not_ready') return t('Não pronto');
  if (ready.value === 'unreachable') return t('Inacessível');
  return t('Verificando…');
});
const readySeverity = computed<string>(() => {
  if (ready.value === 'ready') return 'success';
  if (ready.value === 'not_ready') return 'warn';
  if (ready.value === 'unreachable') return 'danger';
  return 'secondary';
});

async function refreshHealth(): Promise<void> {
  await check();
  await checkReady();
}

onMounted(async () => {
  try {
    await refreshHealth();
  } catch {
    // Both probes swallow their own failures inside refreshHealth; this outer
    // catch matches the original allSettled behaviour so a mount rejection
    // never propagates as unhandled.
  }
});
</script>

<style scoped>
.assistant-config-health-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.assistant-config-health-label {
  font-weight: 600;
  color: var(--p-text-muted-color);
  min-width: 9rem;
}

.assistant-config-refresh {
  margin-top: 0.25rem;
}
</style>
